import { isEmpty } from 'lodash';

import { FilterTypes } from '../constants/FilterTypes';

const countSelectedFilters = (filters, values) =>
  filters.reduce(
    (acc, filter) => acc + (isFilterSelected(filter, values) ? 1 : 0),
    0,
  );

export const getSelectedFiltersCount = (
  filters,
  values,
  includeTopFilters = true,
) => {
  if (!filters || !values) {
    return 0;
  }

  const totalTopFilters = includeTopFilters
    ? countSelectedFilters(filters.top, values)
    : 0;

  const overlayFilters = filters.overlay.map((block) => block.filters).flat();
  const totalOverlayFilters = countSelectedFilters(overlayFilters, values);

  return totalTopFilters + totalOverlayFilters;
};

const isFilterSelected = (filter, values) => {
  switch (filter.type) {
    case FilterTypes.KEYWORD:
    case FilterTypes.FREE_TEXT:
    case FilterTypes.CHECKBOX:
    case FilterTypes.EDUCATIONS_YEAR_FROM:
    case FilterTypes.EDUCATIONS_YEAR_TO:
    case FilterTypes.SELECT_WITH_SEARCH_AND_OTHER_OPTIONS:
      return values.query[filter.name];
    case FilterTypes.NUMBER_RANGE:
    case FilterTypes.DECIMAL_RANGE:
    case FilterTypes.YEAR_RANGE:
      return (
        !!values.query[`min_${filter.name}`] ||
        values.query[`min_${filter.name}`] === 0 ||
        !!values.query[`max_${filter.name}`] ||
        values.query[`max_${filter.name}`] === 0
      );
    case FilterTypes.DATE_RANGE:
      return (
        values.query[`min_${filter.name}`] || values.query[`max_${filter.name}`]
      );
    case FilterTypes.LOCATION:
      // Not scalable, we need to handle the location under a real key and use the name of this key, not put it hardcoded at the root of values
      return (
        values.query.online || !!values.query.lat || values.query.lat === 0
      );
    case FilterTypes.BOOLEAN:
      return (
        values.query[filter.name] === '0' || values.query[filter.name] === '1'
      );
    case FilterTypes.SELECT:
    case FilterTypes.FULLTEXT_SELECT:
    case FilterTypes.INDUSTRIES:
    case FilterTypes.SKILLS:
    case FilterTypes.NATIONALITIES:
    case FilterTypes.SUB_NETWORKS:
    case FilterTypes.COMPANIES:
    case FilterTypes.SCHOOLS:
    case FilterTypes.FIELD_OF_STUDIES:
    case FilterTypes.DEGREES:
      return !isEmpty(values.query[filter.name]);
    case FilterTypes.DOUBLE_SELECT:
      return (
        values.query[filter.name]?.root_value ||
        !isEmpty(values.query[filter.name]?.child_value)
      );
    default:
      return false;
  }
};
